import { Component, Input } from '@angular/core';
import { ApresentacaoRecurso, CapturaRecurso } from '../apresentacoes-recursos';

@Component({
  selector: 'app-previa-recurso',
  templateUrl: './previa-recurso.component.html',
  styleUrls: ['./previa-recurso.component.scss']
})
export class PreviaRecursoComponent {
  @Input() miniatura = false;
  capturas: CapturaRecurso[] = [];
  indice = 0;

  @Input() set previa(valor: ApresentacaoRecurso['previa']) {
    this.capturas = valor?.imagem ? [valor, ...(valor.outrasCapturas || [])] : [];
    this.indice = 0;
  }

  get captura(): CapturaRecurso | undefined {
    return this.capturas[this.miniatura ? 0 : this.indice];
  }
}
